export default "__VITE_ASSET__C1JDvu9m__";